/**
 * Automation Shared Store
 */

import { createStore } from '@commandDrivenStateEngine/core/createStore';
import { Policy } from '@commandDrivenStateEngine/core/policies';
import { ClientLibraryType } from '@bett3r-dev/teselly-client-library';
import { initialState, AutomationSharedState } from './state';
import { handlers } from './handlers';
import { invariants } from './invariants';
import { AutomationSharedCommand } from './commands';
import { createRulesQueryPolicy } from './policies/rulesQueryPolicy';

export { selectors } from './state';

const store = createStore({
  name: 'automation-shared',
  initialState,
  handlers,
  invariants
});

export const {
  useSelector: useAutomationSharedSelector,
  useErrors: useAutomationSharedErrors,
  useDispatch: useAutomationSharedDispatch,
  usePolicies: useAutomationSharedPolicies,
  getState: getAutomationSharedState,
  dispatch: dispatchAutomationSharedCommand
} = store;

/**
 * Policy factory - creates policies for the shared automation store.
 * Policies are added as the domain grows (rulesQueryPolicy in T3).
 */
export const createAutomationSharedPolicies = (
  backend: ClientLibraryType
): Policy<AutomationSharedState, AutomationSharedCommand>[] => [
  createRulesQueryPolicy( backend )
];
